import React from 'react';
import { Card } from "react-bootstrap";
import facePetraBenedek from "../../assets/img/facePetraBenedek.jpg";
import ShowMoreText from "react-show-more-text";
import projPetraBenedek_control_systems from "../../assets/img/projPetraBenedek_control_systems.png";

const Petra_Benedek_control_systems = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={projPetraBenedek_control_systems} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={facePetraBenedek}
              /* this will be the text on the banner */
              alt="Contribution Evaluation & Privacy in Federated Learning"
            />{" "}
            <p className="text7">Petra Benedek</p>
            <br />
            <p className="text8">
              Assistant Professor{" "}
            </p>
            <p className="text8">Department of Management and Business Economics, BME </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            The research explores the differences between the internal control systems of publicly owned companies and the 
            compliance management practices of these organizations. The data were collected through a questionnaire survey 
            with the companies’ internal auditors and compliance officers. Although all the organizations studied recognize 
            the value of compliance, there are significant differences in practice, structure, decentralization, and 
            cooperation with internal audit.
            <br />
            The task during the project is the statistical analysis of two questionnaire surveys. The students have to cooperate 
            with economists and engineers in the analysis and interpretation of the data. Since the raw data is in Hungarian, we 
            expect the students to speak both English and Hungarian. The output of the work is a conference presentation and a 
            scientific article, which is prepared jointly with the research participants.
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Petra_Benedek_control_systems;